export const GESTOR_FEEDBACK_AREA_OPTIONS = [
  'Mídias',
  'Planejamento',
  'Design',
  'SEO',
  'Conteúdo',
  'Performance',
  'Projetos',
  'Suporte',
  'Comunicação',
  'Inovação',
  'Outros',
] as const

export type GestorFeedbackArea = (typeof GESTOR_FEEDBACK_AREA_OPTIONS)[number]

export type GestorFeedbackDocumentFormValues = {
  authorId: string
  dataFeedback: string
  areaAtuacao: string
  situacao: string
  evidenciaUrl: string | null
  evidenciaFileName: string | null
  evidenciaMimeType: string | null
  evidenciaLink: string
  reportado: boolean
  dataReport: string
  observacoesReporte: string
}

export function createEmptyFeedbackDocumentForm(defaultAuthorId = ''): GestorFeedbackDocumentFormValues {
  const today = new Date().toISOString().slice(0, 10)
  return {
    authorId: defaultAuthorId,
    dataFeedback: today,
    areaAtuacao: '',
    situacao: '',
    evidenciaUrl: null,
    evidenciaFileName: null,
    evidenciaMimeType: null,
    evidenciaLink: '',
    reportado: false,
    dataReport: '',
    observacoesReporte: '',
  }
}

export function formatFeedbackDate(iso: string | null | undefined) {
  if (!iso) return '—'
  return new Date(iso).toLocaleDateString('pt-BR')
}
